"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Card = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _ = require("../../");

var Card = function Card(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children"]);
  return _react.default.createElement(_.Flex, rest, children);
};

exports.Card = Card;
Card.defaultProps = {
  border: 1,
  bg: 'white',
  p: 3,
  borderColor: 'blue.mid',
  borderRadius: 3,
  flexDirection: 'column',
  boxShadow: 'card'
};